import * as React from 'react';
import { useForm, SubmitHandler } from "react-hook-form"
import { InputTextField } from '../FormFields/RenderInputTextField';
import { Label } from '../../types/Label';
import { InputColorField } from '../FormFields/RenderInputColorField';
import { useDispatch, useSelector } from "react-redux";
import { hideChildModal, hideModal } from "../../data/modal";
import { createLabel, updateLabel, deleteLabel, removeLabel } from '../../data/labels';

import {
    Button,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@mui/material";

import {
    Close as CloseIcon,
    Delete as DeleteIcon,
    Save as SaveIcon,
} from '@mui/icons-material';

const LabelForm = ({ label, callback }) => {
  const dispatch = useDispatch();

  const selectedData = useSelector((state) => ({
    modal: state.modal,
  }));

  const { handleSubmit, control, formState } = useForm<Label>({
    defaultValues: label ?? new Label(),
  });
  const { isSubmitting } = formState;

  const [confirmOpen, setConfirmOpen] = React.useState(false);

  const onSubmit: SubmitHandler<Label> = (data) => {
    if (label) {
      dispatch(updateLabel(data));
    } else {
      dispatch(createLabel(data, callback));
    }
  };

  const handleCloseForm = () => {
    if (selectedData.modal.childModal) {
        dispatch(hideChildModal());
    } else {
        dispatch(hideModal());
    }
  };

  const handleConfirmDelete = () => {
    if (label) {
      dispatch(removeLabel(label));
    }
    setConfirmOpen(false);
    handleCloseForm();
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container xs={12}>
          <Grid item xs={12} className='form-fields-container'>
            <Grid item xs={12} sm={4}>
              <InputColorField
                name='color'
                label='Color'
                control={control}
                required
              />
            </Grid>
            <Grid item xs={12} sm={8}>
              <InputTextField
                name='name'
                label='Name'
                control={control}
                required
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className='button-wrapper'>
            <Grid container gap={2}>
              <Button
                onClick={handleCloseForm}
                disabled={isSubmitting}
                variant='contained'
              >
                <CloseIcon fontSize="inherit" />&nbsp;Close
              </Button>

              {label && (
                <Button
                  onClick={() => setConfirmOpen(true)}
                  disabled={isSubmitting}
                  variant="contained"
                  color="error"
                >
                  <DeleteIcon fontSize="inherit" />&nbsp;Delete
                </Button>
              )}
            </Grid>

            <Button
              type='submit'
              disabled={isSubmitting}
              variant='contained'
            >
              <SaveIcon fontSize="inherit" />&nbsp;Save
            </Button>
          </Grid>
        </Grid>
      </form>
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this label? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmOpen(false)}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            disabled={isSubmitting}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LabelForm;